import { ActionContract } from "./registry-contract";
import { RightRequirement } from "./trigger-contract";

export interface ActionDisplayLoc {
  /** The friendly or display name for the action */
  locKey: string;

  /** The localization App Id for the action implementation. */
  locAppId: string;
}

/** The implementaiton of a specific action, registered with the ActionRegistry to provide arbitrary executable logic to be invoked by ActionTriggers. */
export interface ActionImplementation<T> {
  /** Gets the eligibility of this action implementation instance */
  /** @param actionContext The current context of the action trigger, used to calculate eligibility for this implementation to be executed. */
  getEligibility(actionContext: T): any;

  /** Invokes the action using the actionContext submitted. ActionImplementations are expected to communicate success or failure through the action deferral object. */
  /** @param actionContract The collection of state the implementation (and hosted views) need to complete an action. */
  invoke(actionContract: ActionContract<T>): HostedActionContent;

  /** The name which triggers this action implementation. These names should be scoped, such that an action initiated from a specific codebase would be unique, e.g. "MST_CaseCreate". */
  triggeredBy: string;

  /** The rights required for this action implementation to be considered eligible to run. */
  requiredRights?: RightRequirement[];

  /** The list of Action UX Types that this implementation supports, prioritized from most desired to least desired. */
  uxTypes: any[];

  /** Holds the value for locAppId and locKey which is used to localize the friendly name for the action. */
  displayName?: ActionDisplayLoc;

  /** Holds the id to detect this action while end to end automation test. Optional since if this not provided, locKey for displayName is the default.*/
  automationId?: string;

  /** Optional hoverstate action trigger name to be used for actions with hover menu */
  hoverActionName?: string;
}

/** Container object for instructions from the action implementation to the registry on how to host its content. */
export class HostedActionContent {
  /** the content the action implementation is requesting the registry to host to enable action completion. */
  content: string;
}
